import { AnyAction, Dispatch } from "redux";
import { CMDSpFishprawncrabStatistics, ICommand } from "../live";
import { AbstractHandler } from "./AbstractHandler";
import { FishPrawnCrabStatistics } from "@/models/games/fishprawncrab";
import { hostsSliceActions } from "@/modules/host/slice";

export class CMDSpFishPrawnCrabStatisticsHandler extends AbstractHandler {
    _command: CMDSpFishprawncrabStatistics;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDSpFishprawncrabStatistics;
    }
    handle(dispatch: Dispatch<AnyAction>): void {
        const statistics = {} as FishPrawnCrabStatistics;
        console.log(statistics, dispatch);
        const hostId = this._command.HostID;
        const val = this._command.Statistics;
        const totalNum: number =
            val.FishCount +
            val.CalabashCount +
            val.TigerCount +
            val.CrabCount +
            val.PrawnCount +
            val.RoosterCount;

        statistics.FishCount = val.FishCount;
        statistics.PrawnCount = val.PrawnCount;
        statistics.CalabashCount = val.CalabashCount;
        statistics.TigerCount = val.TigerCount;
        statistics.CrabCount = val.CrabCount;
        statistics.RoosterCount = val.RoosterCount;

        statistics.FishRate = val.FishCount / totalNum * 100;
        statistics.PrawnRate = val.PrawnCount / totalNum * 100;
        statistics.CalabashRate = val.CalabashCount / totalNum * 100;
        statistics.TigerRate = val.TigerCount / totalNum * 100;
        statistics.CrabRate = val.CrabCount / totalNum * 100;
        statistics.RoosterRate = val.RoosterCount / totalNum * 100;

        dispatch(hostsSliceActions.updateStatistic({ hostId, statistics }));
    }
}